import { loadExternalConfig } from './config-loader';

declare global {
  var IS_PRODUCTION: boolean;
}

globalThis.IS_PRODUCTION = import.meta.env.PROD;

async function init(): Promise<void> {
  try {
    await loadExternalConfig();
  } catch (error) {
    console.error(error);
  }
  import('./boot');
}

init();
